
export default function OrdersChart({ orderSales = [] }) {
  const safeOrderSales = Array.isArray(orderSales) ? orderSales : [];
  const total = safeOrderSales.reduce((sum, item) => sum + (item?.count || 0), 0);

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-6">Order Status Distribution</h3>
      
      <div className="flex items-center justify-center mb-6">
        <div className="relative w-48 h-48">
          <svg className="w-full h-full transform -rotate-90" viewBox="0 0 100 100">
            {safeOrderSales.map((item, index) => {
              const previousPercentages = safeOrderSales.slice(0, index).reduce((sum, prev) => sum + (prev?.percentage || 0), 0);
              const percentage = item?.percentage || 0;
              const strokeDasharray = `${percentage} ${100 - percentage}`;
              const strokeDashoffset = -previousPercentages;
              const colorClass = item?.color || 'bg-gray-500';
              const strokeColor = colorClass.replace('bg-', '').replace('-500', '');
              
              return (
                <circle
                  key={index}
                  cx="50"
                  cy="50"
                  r="40"
                  fill="transparent"
                  stroke={strokeColor}
                  strokeWidth="8"
                  strokeDasharray={strokeDasharray}
                  strokeDashoffset={strokeDashoffset}
                  className="transition-all duration-300 hover:stroke-width-10"
                />
              );
            })}
          </svg>
          <div className="absolute inset-0 flex items-center justify-center flex-col">
            <span className="text-2xl font-bold text-gray-800">{total}</span>
            <span className="text-sm text-gray-500">Total Orders</span>
          </div>
        </div>
      </div>
      
      <div className="space-y-3">
        {safeOrderSales.map((item, index) => (
          <div key={index} className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className={`w-3 h-3 rounded-full ${item?.color || 'bg-gray-500'}`}></div>
              <span className="text-sm font-medium text-gray-700">{item?.status || 'Unknown'}</span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="text-sm text-gray-600">{item?.count ?? 0}</span>
              <span className="text-xs text-gray-500">({item?.percentage ?? 0}%)</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

